import React from 'react';
import { styled } from '@mui/material';
import moment from 'moment';

import { Avatar, Stack, Tag, Text } from 'shell/components';

const ActivityItem = ({ user, text, createdOn }) => {
    return (
        <Stack direction={'row'} spacing={2}>
            <Avatar size={'small'} user={user} />
            <Stack>
                <CustomText component={'span'} variant={'p2'}>
                    {user.role === 'instructor' && (
                        <>
                            <Tag type={'role'} value={'instructor'} />{' '}
                        </>
                    )}
                    {text}
                </CustomText>
                <Text color={'light'} variant={'p3'}>
                    {moment(createdOn).fromNow()}
                </Text>
            </Stack>
        </Stack>
    );
};

const CustomText = styled(Text)(() => {
    return {
        lineHeight: '1.25rem',
    };
});

export default ActivityItem;
